import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { Input } from "rsuite";
import Pagination from "rsuite/Pagination";
import Swal from "sweetalert2";
import { APi } from "../../../Api";
import { exportAddAtom } from "../../../Atoms/exportAdd.atom";
import ExportAdd from "../../../Components/Common/ExportAdd";
import Filter from "../../../Components/Common/Filter";
import Grid from "../../../Components/Grid";
import Responsive from "../../../Components/Responsive";
import validate from "../../../Helpers/validate";
import AddEdit from "./AddEdit.component";
export default function Employee(props) {
  // STATE
  const [data, setdata] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [Positions, setPositions] = useState([]);

  const [filterModel, setfilterModel] = useState({
    q: "",
    page: 1,
    take: 50,
    clientType: 1,
    isCCA: false,
  });
  // --- add edit model ---
  const [error, setError] = useState("");
  const [model, setmodel] = useState({
    phones: "",
    emails: "",
    name: "",
    address: "",
  });

  // ATOMS
  const [state, setstate] = useRecoilState(exportAddAtom);
  // HELPERS
  const reset = () => {
    setmodel({ phones: "", emails: "", name: "", address: "" });
    setError("");
  };
  // useEffect(() => {

  // }, []);

  // API CALLS
  const fetch = () => {
    setstate((prev) => {
      return { ...prev, loading: true };
    });
    APi.createAPIEndpoint(APi.ENDPOINTS.Employee, filterModel)
      .fetchAll()
      .then((res) => {
        setdata(res.data.data);
        setstate((prev) => {
          return { ...prev, loading: false };
        });
        settotalCount(res.data.totalCount);
      })
      .catch((e) => {
        setError(e.Message);
        setstate((prev) => {
          return { ...prev, loading: false };
        });
      });
  };
  const save = () => {
    let msg = validate(model, [
      { name: "Nom" },
      // { code: "Code" },
    ]);
    if (msg) setError(msg);
    else {
      setstate((prev) => {
        return { ...prev, loading: true };
      });
      if (model.id) {
        APi.createAPIEndpoint(APi.ENDPOINTS.Employee)
          .update(model.id, model)
          .then((res) => {
            fetch();
            setstate((prev) => {
              return { ...prev, open: false, loading: false };
            });
            reset();
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Élément a été bien modifié !",
              showConfirmButton: false,
              timer: 1500,
            });
          })
          .catch((e) => {
            setError(e.Message);
            setstate((prev) => {
              return { ...prev, loading: false };
            });
          });
      } else {
        APi.createAPIEndpoint(APi.ENDPOINTS.Employee)
          .create(model)
          .then((res) => {
            console.log(res);
            fetch();
            reset();
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Element a été bien ajouté !",
              showConfirmButton: false,
              timer: 1500,
            });
            setstate((prev) => {
              return { ...prev, open: false, loading: false };
            });
          })
          .catch((e) => {
            setError(e.Message);
            setstate((prev) => {
              return { ...prev, loading: false };
            });
          });
      }
    }
  };
  const deleteAction = (id) => {
    APi.createAPIEndpoint(APi.ENDPOINTS.Employee)
      .delete(id)

      .then((res) => {
        fetch();
        Swal.fire("Supprimé !", "", "success");
      })
      .catch((e) => setError(e.Message));
  };
  const getBYId = (id) => {
    setError("");

    setmodel(data.find((el) => el.id == id));
  };
  const fetchPositions = (q, forFilter = true) => {
    if (typeof q == "undefined" || q.length > 2) {
      APi.createAPIEndpoint(
        APi.ENDPOINTS.EmployeePosition,
        { q },
        "/autocomplete"
      )
        .customGet()
        .then((res) => setPositions(res.data));
    }
  };
  // LIFE CYCLES
  useEffect(() => {
    fetch();
    fetchPositions();
  }, [filterModel.page, filterModel.take]);
  return (
    <div>
      <Filter search={() => fetch()}>
        <Responsive className="p-10">
          <label>Nom: </label>

          <Input
            placeholder="recherche"
            onChange={(q) => {
              setfilterModel((prev) => {
                return { ...prev, q };
              });
            }}
          />
        </Responsive>
        {/* <Responsive m={6} l={6} xl={6} className="p-10">
          <label>Type de Client :</label>
          <SelectPicker
            searchable={false}
            data={[{ label: "Tout", value: 0 }].concat(clientTypes)}
            block
            noSearch
            value={filterModel.clientType}
            onSelect={(clientType) => {
              setfilterModel((prev) => {
                return { ...prev, clientType };
              });
            }}
          />
        </Responsive> */}
      </Filter>
      <ExportAdd
        ActionOnClose={reset}
        // excelData={multiDataSet(data)}
        // nameExcel="client"
        noExport
        size="md"
        save={save}
        AddComponent={
          <AddEdit
            error={error}
            model={model}
            _setmodel={setmodel}
            Positions={Positions}
            fetchPositions={(q) => fetchPositions(q, false)}
          />
        }
      />{" "}
      <Grid
        editAction={(id) => {
          getBYId(id);

          setstate((prev) => {
            return { ...prev, open: true };
          });
        }}
        deleteAction={deleteAction}
        actionKey="id"
        noAdvancedActions // for custom advanced actions
        columns={columns}
        rows={data}
      />
      <div style={{ padding: 20, background: "#fff" }}>
        <Pagination
          prev
          next
          first
          last
          ellipsis
          boundaryLinks
          maxButtons={5}
          size="md"
          layout={["total", "-", "limit", "|", "pager", "skip"]}
          total={totalCount}
          limitOptions={[10, 20, 50, 100]}
          limit={filterModel.take}
          activePage={filterModel.page}
          onChangePage={(page) => {
            window.scrollTo(0, 0);
            setfilterModel((prev) => {
              return { ...prev, page };
            });
          }}
          onChangeLimit={(take) => {
            console.log(take);
            setfilterModel((prev) => {
              return { ...prev, take, page: 1 };
            });
          }}
        />
      </div>
      {/* <button
        style={{ display: "none" }}
        onClick={() => {
          let _Positions = Positions.filter(
            (c) => !c[1].includes("VO ") && !c[1].includes("UMRA ")
          );
          _Positions.map((c) => {
            let m = new ClientModel();
            m.name = c[1];
            m.address = c[6];
            m.emails = c[10] ? c[10].replaceAll(";", ",") : "";
            m.phones = c[7];
            m.code = c[20];
            m.taxCode = c[5];
            setTimeout(() => {
              APi.createAPIEndpoint(APi.ENDPOINTS.Client)
                .create(m)
                .then((res) => {})
                .catch((e) => {});
            }, 2000);
          });
          console.log(_Positions);
        }}
      >
        setPositions
      </button> */}
    </div>
  );
}

const columns = [
  {
    value: "name",
    name: "Nom",
    render: (v) => <a>{v}</a>,
  },

  {
    value: "position",
    name: "Position",
    render: (v) => <b>{v && v.name}</b>,
  },

  {
    value: "address",
    name: "Adresse",
    render: (v) => <i style={{ color: "#232323" }}>{v}</i>,
  },
  {
    value: "email",
    name: "Email",
    render: (k) => {
      return (
        <div style={{ maxWidth: "260px", overflow: "auto" }}>
          <a
            href={"mailto:" + k}
            style={{
              display: "inline-block",
              margin: "5px",
              border: "1px solid rgba(93,120,255,0.2)",
              borderRadius: "3px",
              padding: "3px 4px",
            }}
          >
            {k}
          </a>
        </div>
      );
    },
  },

  {
    value: "phones",
    name: "Numéros de téléphones",
    render: (v) => {
      return (
        <div style={{ maxWidth: "260px", overflow: "auto" }}>
          {v &&
            v.split(",").map((k, i) => (
              <a
                href={"tel:" + k}
                style={{
                  color: "rgba(11,150,102,1)",
                  display: "inline-block",
                  margin: "5px",
                  border: "1px solid rgba(11,150,102,0.2)",
                  borderRadius: "3px",
                  padding: "3px 4px",
                }}
              >
                {k}
              </a>
            ))}
        </div>
      );
    },
  },
];
